import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { modalClose, modalAlertaInfo, modalAlertaClean } from '../../layout/redux/layoutActions'
import { criarDashboard, obterPlanejamentoEscolhidoYT7dias, obterPlanejamentoEscolhidoYT30dias } from './redux/dashboardActions'
import { Modal, Button, Input, validacaoForm, verificaValidacao } from '../../components'
import { buildConfig } from './topicconfigbuilder'
import moment from 'moment'
import 'moment/locale/pt-br'
import 'moment/locale/es'
import './criar.scss'
import { PopoverCentralAjuda } from '../../components/popovercentralajuda/popovercentralajuda'


const Criar = () => {
  const dispatch = useDispatch()
  //const { sistema, statusModal, usuario } = useSelector(state => state.layoutState)
  //const { projeto, filtersProvisorio } = useSelector(state => state.comentariosnovosState)


  /* VERSÃO PEGANDO O PERIODO DE COMENTARIOSNOVO
  const layoutState = useSelector(state => state.layoutState) // ← layoutState completo
  const { sistema, statusModal, usuario } = layoutState // ← desestruturação mantida para compatibilidade
  const { projeto, filtersProvisorio } = useSelector(state => state.comentariosnovosState)
  */

  //VERSÃO ATUALIZADA PEGANDO O PERIODO DO LAYOUTSTATE, QUE CONTÉM O ÚLTIMO PERÍODO SETADO
  const layoutState = useSelector(state => state.layoutState)
  const { sistema, statusModal, usuario, filters: filtersLayout } = layoutState

  const { projeto, filtersProvisorio: filtersComentarios } =
  useSelector(state => state.comentariosnovosState)

  const filtersProvisorio = filtersLayout ?? filtersComentarios
  
  const { planoSelecionado } = useSelector(state => state.plano7diasState)
  const { planoSelecionado: plano30dias } = useSelector(state => state.plano30diasState)

  
  const nls = require(`./nls/${sistema.idioma}.json`)
  const nlsPopup = require(`../../layout/nlsPopup/${sistema.idioma}.json`)
  const nlsContexto = require(`../centralAjuda/nlscontexto/${sistema.idioma}.json`)

  const idarray = [140];


  const [form, setForm] = useState({
    titulo: '',
    autor: '',
    periodoAnalisado: '',
    youtube: ''
  })

  const [erro, setErro] = useState({})
  const [loading, setLoading] = useState(false)
  
  const [topicosDisponiveis, setTopicosDisponiveis] = useState([])
  const [topicosSelecionados, setTopicosSelecionados] = useState([])

  // ✅ NOVA FUNÇÃO: Filtrar tópicos baseado no projeto
  const filtrarTopicosPorProjeto = (topicos, projeto) => {
    if (!topicos || !projeto) return [];
    
    const { temMenuEstabelecimento, temMenuProduto } = projeto;
    
    return topicos.filter(topico => {
      const { tipoprojeto } = topico;
      
      // Quando ambos são false
      if (!temMenuEstabelecimento && !temMenuProduto) {
        return tipoprojeto === "todo";
      }
      
      // Quando temMenuEstabelecimento é true
      if (temMenuEstabelecimento) {
        return tipoprojeto === "todo" || tipoprojeto === "estabelecimento";
      }
      
      // Quando temMenuProduto é true  
      if (temMenuProduto) {
        return tipoprojeto === "todo" || tipoprojeto === "produto";
      }
      
      return false;
    });
  };


  const removerTopicosNaoPermitidos = (topicos) => {
  if (!topicos) return []

  return topicos.filter(topico =>
    topico.key !== 'plano7dias' &&
    topico.key !== 'plano30dias'
  )
}

  
// ✅ NOVA FUNÇÃO: Específica para o plano
const obterPeriodoAnalisadoPlano7dias = () => {
  // ✅ Se existe planoSelecionado, usar seus dados
  if (planoSelecionado && Object.keys(planoSelecionado).length > 0) {
    console.log('📋 Plano selecionado encontrado:', {
      idPlanejamento: planoSelecionado.idPlanejamento,
      nome: planoSelecionado.nome
    })
    return `${planoSelecionado.nome || 'Plano 7 Dias'}`
  }

  // ✅ Se não tem planoSelecionado, calcular período da semana anterior COMPLETA
  if (!planoSelecionado || Object.keys(planoSelecionado).length === 0) {
    const hoje = moment()
    
    // ✅ CORREÇÃO SEGURA: Calcular semana anterior manualmente
    // Encontrar a segunda-feira da semana atual
    const diaDaSemana = hoje.day() // 0=domingo, 1=segunda, ..., 6=sábado
    const diasDesdeSegunda = diaDaSemana === 0 ? 6 : diaDaSemana - 1
    
    // Segunda-feira da semana atual
    const segundaAtual = hoje.clone().subtract(diasDesdeSegunda, 'days')
    // Domingo da semana anterior (dia anterior à segunda atual)
    const domingoPassado = segundaAtual.clone().subtract(1, 'day')
    // Segunda-feira da semana anterior
    const segundaPassada = domingoPassado.clone().subtract(6, 'days')
    
    // ✅ CORREÇÃO: Passar sistema.idioma para formatarData
    console.log("Data1 Entrou em fomatarData1")
    const dataInicialFormatada = formatarData(segundaPassada.toDate(), sistema.idioma)
    const dataFinalFormatada = formatarData(domingoPassado.toDate(), sistema.idioma)
    
    const periodoCalculado = `${nls.desdeperiodo || 'De'} ${dataInicialFormatada} ${nls.ateperiodo || 'até'} ${dataFinalFormatada}`
    
    console.log('📅 Período calculado (SEMANA ANTERIOR COMPLETA):', {
      sistemaIdioma: sistema.idioma,
      diaDaSemana: diaDaSemana,
      diasDesdeSegunda: diasDesdeSegunda,
      segundaPassada: segundaPassada.format('YYYY-MM-DD'),
      domingoPassado: domingoPassado.format('YYYY-MM-DD'),
      dataInicialFormatada: dataInicialFormatada,
      dataFinalFormatada: dataFinalFormatada,
      periodoFormatado: periodoCalculado
    })
    
    return periodoCalculado
  }

  return ''
}

const obterPeriodoAnalisadoPlano30dias = () => {
    // ✅ Se existe planoSelecionado30dias, usar seus dados
    if (plano30dias  && Object.keys(plano30dias).length > 0) {
      console.log('📋 Plano 30 dias selecionado encontrado:', {
        idPlanejamento: plano30dias.idPlanejamento,
        nome: plano30dias.nome
      })
      return `${plano30dias.nome || 'Plano 30 Dias'}`
    }

    // ✅ Se não tem planoSelecionado30dias, calcular período do mês anterior
    if (!plano30dias || Object.keys(plano30dias).length === 0) {
      const hoje = moment()
      
      // ✅ Calcular primeiro e último dia do mês anterior
      const primeiroDiaMesAnterior = hoje.clone().subtract(1, 'month').startOf('month')
      const ultimoDiaMesAnterior = hoje.clone().subtract(1, 'month').endOf('month')
      
      const dataInicialFormatada = formatarData(primeiroDiaMesAnterior.toDate(), sistema.idioma)
      const dataFinalFormatada = formatarData(ultimoDiaMesAnterior.toDate(), sistema.idioma)
      
      const periodoCalculado = `${nls.desdeperiodo || 'De'} ${dataInicialFormatada} ${nls.ateperiodo || 'até'} ${dataFinalFormatada}`
      
      console.log('📅 Período calculado (MÊS ANTERIOR):', {
        sistemaIdioma: sistema.idioma,
        primeiroDiaMesAnterior: primeiroDiaMesAnterior.format('YYYY-MM-DD'),
        ultimoDiaMesAnterior: ultimoDiaMesAnterior.format('YYYY-MM-DD'),
        dataInicialFormatada: dataInicialFormatada,
        dataFinalFormatada: dataFinalFormatada,
        periodoFormatado: periodoCalculado
      })
      
      return periodoCalculado
    }

    return ''
  }



// ✅ TESTE: Para ver o resultado no console
/*
useEffect(() => {
  if (statusModal === 'criar') {
    const periodoTeste = obterPeriodoAnalisadoPlano7dias();
    console.log('🔍 RESULTADO DO PERÍODO CALCULADO:', periodoTeste);
    console.log('🌐 IDIOMA ATUAL:', sistema.idioma);
  }
}, [statusModal]);
*/


  // Função para formatar data conforme o idioma
  const formatarData = (data, idioma) => {   
    if (!data) return ''
    
    const idiomaMoment = idioma === 'esp' ? 'es' : idioma
    moment.locale(idiomaMoment)
    
    if (idioma === 'en-US') {     
      return moment(data).format('MM/DD/YYYY')
    } else {
      return moment(data).format('DD/MM/YYYY')
    }
  }

  // Função para obter o período analisado
  const obterPeriodoAnalisado = () => {
    if (!filtersProvisorio) return ''

    const { typeSelect, dataInicial, dataFinal, ciclo } = filtersProvisorio

    if (typeSelect?.id === 'Data' && dataInicial && dataFinal) {
      const dataInicialFormatada = formatarData(dataInicial, sistema.idioma)
      const dataFinalFormatada = formatarData(dataFinal, sistema.idioma)
      return `${nls.desdeperiodo || 'De'} ${dataInicialFormatada} ${nls.ateperiodo || 'até'} ${dataFinalFormatada}`
    } 
    else if (typeSelect?.id === 'Ciclo' && ciclo?.cicloPorExtenso) {
      return ciclo.cicloPorExtenso
    }
    
    return ''
  }

  // ✅ NOVA FUNÇÃO: Obter datas do período (dataInicial e dataFinal) para o builder
  const obterDatasDoPeriodo = () => {
    if (!filtersProvisorio) {
      throw new Error('FiltersProvisorio não encontrado');
    }

    const { typeSelect, dataInicial, dataFinal, ciclo } = filtersProvisorio;

    if (typeSelect?.id === 'Data' && dataInicial && dataFinal) {
      // Já tem datas definidas
      return { 
        dataInicial: moment(dataInicial).format('YYYY-MM-DD'),
        dataFinal: moment(dataFinal).format('YYYY-MM-DD')
      };
    } 
    else if (typeSelect?.id === 'Ciclo' && ciclo && ciclo.ano && ciclo.mes) {
      // ✅ CONVERTE CICLO PARA DATAS
      const ano = parseInt(ciclo.ano);
      const mes = parseInt(ciclo.mes);
      
      // Primeiro dia do mês
      const primeiraData = moment(`${ano}-${mes.toString().padStart(2, '0')}-01`);
      
      // Último dia do mês
      const ultimaData = moment(primeiraData).endOf('month');
      
      return {
        dataInicial: primeiraData.format('YYYY-MM-DD'),
        dataFinal: ultimaData.format('YYYY-MM-DD')
      };
    }
    
    // ✅ RETORNA ERRO SE NÃO ENCONTRAR DATAS
    throw new Error('Não foi possível determinar o período. Verifique se as datas ou ciclo estão configurados corretamente.');
  };

  // ✅ CORREÇÃO: Inicialização separada com filtro
  useEffect(() => {
    if (nls.topicos && nls.topicos.length > 0) {
      
      const topicosFiltradosProjeto = filtrarTopicosPorProjeto(nls.topicos, projeto)
      const topicosFiltradosFinal = removerTopicosNaoPermitidos(topicosFiltradosProjeto)

      setTopicosDisponiveis([...topicosFiltradosFinal])
      setTopicosSelecionados([])
    }
  }, [nls.topicos, projeto]); // ✅ Adicionar projeto como dependência

  useEffect(() => {
    if (statusModal === 'criar') {
      setErro({})
      
      // VALORES PRÉ-PREENCHIDOS
      const tituloPreenchido = projeto?.nomeProjeto || ''
      const autorPreenchido = usuario ? `${usuario.nome || ''} ${usuario.sobrenome || ''}`.trim() : ''
      const periodoPreenchido = obterPeriodoAnalisado()

      setForm({
        titulo: tituloPreenchido,
        autor: autorPreenchido,
        periodoAnalisado: periodoPreenchido,
        youtube: ''
      })
      
      // ✅ CORREÇÃO: Reset separado com filtro
      if (nls.topicos && nls.topicos.length > 0) {
        
        const topicosFiltradosProjeto = filtrarTopicosPorProjeto(nls.topicos, projeto)
        const topicosFiltradosFinal = removerTopicosNaoPermitidos(topicosFiltradosProjeto)

        setTopicosDisponiveis([...topicosFiltradosFinal])
        setTopicosSelecionados([])

      }
      
      setLoading(false)
    }
  }, [statusModal, projeto, usuario, filtersProvisorio, sistema.idioma, nls.topicos])

  // Campos obrigatórios
  const formRequired = {
    titulo: '',
    autor: '',
    periodoAnalisado: '',
    topicos: ''
  }

  const handleChange = (e) => {
    setForm({ ...form, [e.name]: e.value })
  }

  const handleClose = () => {
    dispatch(modalClose())
  }

  const handleSelecionarTopico = (topico) => {
    setTopicosDisponiveis(prev => prev.filter(t => t.key !== topico.key))
    setTopicosSelecionados(prev => [...prev, topico])
  }

  const handleRemoverTopico = (topico) => {
    setTopicosSelecionados(prev => prev.filter(t => t.key !== topico.key))
    setTopicosDisponiveis(prev => [...prev, topico])
  }

  const handleLimparTopicos = () => {
    if (nls.topicos && nls.topicos.length > 0) {
      
      const topicosFiltradosProjeto = filtrarTopicosPorProjeto(nls.topicos, projeto)
      const topicosFiltradosFinal = removerTopicosNaoPermitidos(topicosFiltradosProjeto)

      setTopicosDisponiveis([...topicosFiltradosFinal])
      setTopicosSelecionados([])
    }
  }

  const handleSubmit = async () => {
  console.log('🔴 INICIANDO handleSubmit');
  
  // Validação incluindo tópicos
  const formComTopicos = {
    ...form,
    topicos: topicosSelecionados.length > 0 ? 'preenchido' : ''
  }

  const valid = validacaoForm({ formValues: formComTopicos, formRequired })
  setErro(valid)
  const verify = verificaValidacao(valid)

  if (!verify.value) {
    console.log("❌ ERRO EM CRIAR DASHBOARD - Validação falhou")
    return
  }

  const topicosKeys = topicosSelecionados.map(t => t.key)
  
  console.log('🎯 TÓPICOS SELECIONADOS NA ORDEM:', topicosKeys)
  console.log('📊 TOTAL SELECIONADOS:', topicosSelecionados.length)

  setLoading(true)

  try {
    console.log('🔄 INICIANDO CONSTRUÇÃO DO CONFIG');
    
    // ✅ Obter as datas do período - AGORA PODE LANÇAR ERRO
    let dataInicial, dataFinal;
    try {
      const datas = obterDatasDoPeriodo();
      dataInicial = datas.dataInicial;
      dataFinal = datas.dataFinal;
      console.log('📅 DATAS DO PERÍODO:', { dataInicial, dataFinal });
    } catch (datasError) {
      console.error('❌ ERRO AO OBTER DATAS:', datasError);
      throw new Error(`Erro no período: ${datasError.message}`);
    }
    
    // ✅ Preparar parâmetros do plano 7 dias (CORRETO)
let parametrosPlano = null;

// Vamos permitir remover o tópico se não existir plano real
let topicosKeysFinal = [...topicosKeys];

const topicoPlano7diasSelecionado = topicosKeysFinal.includes('plano7dias');

if (topicoPlano7diasSelecionado) {
  if (planoSelecionado && Object.keys(planoSelecionado).length > 0) {
    // Caso 1: existe plano selecionado (ok)
    parametrosPlano = {
      idPlanejamento: planoSelecionado.idPlanejamento,
      nome: planoSelecionado.nome
    };
    console.log('📋 PARÂMETROS DO PLANO 7 DIAS (selecionado):', parametrosPlano);
  } else {
    // Caso 2/3: não existe plano selecionado -> chamar API externa
    const empresaId = layoutState?.empresa?.empresaId;
    const idiomaIdUser = sistema?.idiomaIdValue;

    console.log('🌐 Buscando planejamento YT7dias via API...', { empresaId, idiomaIdUser });

    const retorno = await dispatch(
      obterPlanejamentoEscolhidoYT7dias({ empresaId, idiomaIdUser })
    );

    console.log('📦 Retorno planejamento YT7dias:', retorno);

    // Se nome === null => não existe plano => remover tópico do config
    if (!retorno?.nome) {
      console.log('⚠️ Sem plano YT7dias. Removendo tópico plano7dias do dashboard.');
      topicosKeysFinal = topicosKeysFinal.filter(k => k !== 'plano7dias');
      parametrosPlano = null;
    } else {
      // Existe nome; idPlanejamento pode ser 0 ou válido, conforme regra
      parametrosPlano = {
        ...(retorno.idPlanejamento && Number(retorno.idPlanejamento) !== 0
          ? { idPlanejamento: Number(retorno.idPlanejamento) }
          : {}),
        nome: retorno.nome
      };
      console.log('📋 PARÂMETROS DO PLANO 7 DIAS (API):', parametrosPlano);
    }
  }
}

    
    // ✅ DEBUG: Verificar se todos os parâmetros existem
    //console.log('📋 PARÂMETROS PARA buildConfig:');
    //console.log('- topicosKeys:', topicosKeys);
    //console.log('- projeto:', projeto);
    //console.log('- dataInicial:', dataInicial);
    //console.log('- dataFinal:', dataFinal);
    //console.log('- parametrosPlano:', parametrosPlano); // ✅ NOVO
    //console.log('- nls:', nls);
    //console.log('- layoutState COMPLETO:', layoutState);
    //console.log('- sistema:', sistema);

    // ✅ Preparar parâmetros do plano 30 dias (CORRETO, com API quando não houver selecionado)
let parametrosPlano30Final = null;

const topicoPlano30diasSelecionado = topicosKeysFinal.includes('plano30dias');

if (topicoPlano30diasSelecionado) {
  if (plano30dias && Object.keys(plano30dias).length > 0) {
    // Caso 1: existe plano selecionado (ok)
    parametrosPlano30Final = {
      idPlanejamento: plano30dias.idPlanejamento,
      nome: plano30dias.nome
    };
    console.log('📋 PARÂMETROS DO PLANO 30 DIAS (selecionado):', parametrosPlano30Final);
  } else {
    // Caso 2/3: não existe plano selecionado -> chamar API externa
    const empresaId = layoutState?.empresa?.empresaId;
    const idiomaIdUser = sistema?.idiomaIdValue;

    console.log('🌐 Buscando planejamento YT30dias via API...', { empresaId, idiomaIdUser });

    const retorno30 = await dispatch(
      obterPlanejamentoEscolhidoYT30dias({ empresaId, idiomaIdUser })
    );

    console.log('📦 Retorno planejamento YT30dias:', retorno30);

    // Se nome === null => não existe plano => remover tópico do config
    if (!retorno30?.nome) {
      console.log('⚠️ Sem plano YT30dias. Removendo tópico plano30dias do dashboard.');
      topicosKeysFinal = topicosKeysFinal.filter(k => k !== 'plano30dias');
      parametrosPlano30Final = null;
    } else {
      // Existe nome; idPlanejamento pode ser 0 ou válido
      parametrosPlano30Final = {
        ...(retorno30.idPlanejamento && Number(retorno30.idPlanejamento) !== 0
          ? { idPlanejamento: Number(retorno30.idPlanejamento) }
          : {}),
        nome: retorno30.nome
      };
      console.log('📋 PARÂMETROS DO PLANO 30 DIAS (API):', parametrosPlano30Final);
    }
  }
}



    // ✅ Construir o config COM OS NOVOS PARÂMETROS (ajustado)
let config;

try {
  // ✅ Monta params do builder SEM incluir plano7dias se não existir plano real
  const builderParams = {
  scope: {
    periodo: {
      ini: dataInicial,
      fim: dataFinal
    }
  },
  ...(parametrosPlano ? { plano7dias: parametrosPlano } : {}),                 // ✅ só inclui se existir
  ...(parametrosPlano30Final ? { plano30dias: parametrosPlano30Final } : {})   // ✅ só inclui se existir
};


  config = buildConfig(
    topicosKeysFinal,      // ✅ usa lista final (pode estar sem plano7dias)
    builderParams,         // ✅ params ajustados
    nls,
    layoutState,
    projeto,
    sistema
  );

  console.log('✅ CONFIG CONSTRUÍDO COM SUCESSO:', config);
} catch (configError) {
  console.error('❌ ERRO AO CONSTRUIR CONFIG:', configError);
  throw new Error(`Erro ao construir config: ${configError.message}`);
}

// ✅ VALIDAR SE O CONFIG TEM COMPONENTES
if (!config.components || config.components.length === 0) {
  throw new Error('Config vazio: nenhum componente foi gerado');
}

console.log('🚀 ENVIANDO PARA CRIAR DASHBOARD...');

const dashboardId = await dispatch(criarDashboard({
  ...form,
  idioma: sistema.idioma,
  topicosSelecionados: topicosKeysFinal, // ✅ usa lista final
  config: config
}));

console.log('✅ Dashboard criado com ID:', dashboardId);

const publicDomain = process.env.REACT_APP_PUBLIC_DASHBOARD_DOMAIN || window.location.origin;
const dashboardUrl = `${publicDomain}/d/${dashboardId}`;
const dashboardLink = `<a href="${dashboardUrl}" target="_blank" rel="noopener noreferrer" style="color: #007bff; text-decoration: underline; word-break: break-all;">${dashboardUrl}</a>`;


    // Fecha o modal do formulário
    handleClose()

    // Mostra modal de sucesso do sistema
    dispatch(
      modalAlertaInfo({
        ...nlsPopup['150'],
        show: true,
        textos: {
          urldashboard: dashboardLink
        },
        btnAction: () => {
          dispatch(modalAlertaClean())
        }
      })
    )
    
  } catch (error) {
  console.error('💥 ERRO CAPTURADO NO handleSubmit:', error)

  // Fecha o modal do formulário ANTES de mostrar o erro
  handleClose()

  // ✅ Captura iderro no formato: { iderro: 701, complemento: null }
  const iderro = error?.response?.data?.iderro;

  // ✅ Se for 701, mostra popup específico; senão mantém o padrão (151)
  const popupKey = iderro === 701 ? '701' : '151';

  // ✅ Fallback para não quebrar caso nlsPopup['701'] não exista
  const popupConfig = nlsPopup?.[popupKey] || nlsPopup?.['151'];

  dispatch(
    modalAlertaInfo({
      ...popupConfig,
      show: true,
      btnAction: () => {
        dispatch(modalAlertaClean())
      }
    })
  )
} finally {
  setLoading(false)
}

}

  const contentForm = () => (
    <div className="modal-criar-dashboard-form">
      <div className="form-fields">
        {/* Linha 1 - Título e Autor lado a lado */}
        <div className="form-row">
          <div className="form-column">
            <Input
              name="titulo"
              label={nls.titulo}
              value={form.titulo}
              placeholder="Digite o título do dashboard"
              action={handleChange}
              required={{
                erro,
                message: nls.mensagem?.obrigatorio || "Campo obrigatório",
                pattern: formRequired.titulo
              }}
              disabled={loading}
            />
          </div>
          <div className="form-column">
            <Input
              name="autor"
              label={nls.autor}
              value={form.autor}
              placeholder="Digite o nome do autor"
              action={handleChange}
              required={{
                erro,
                message: nls.mensagem?.obrigatorio || "Campo obrigatório", 
                pattern: formRequired.autor
              }}
              disabled={loading}
            />
          </div>
        </div>

        {/* Linha 2 - Período e YouTube lado a lado */}
        <div className="form-row">
          <div className="form-column">
            <Input
              name="periodoAnalisado"
              label={nls.periodoanalisado}
              value={form.periodoAnalisado}
              placeholder="Período analisado"
              action={handleChange}
              required={{
                erro,
                message: nls.mensagem?.obrigatorio || "Campo obrigatório",
                pattern: formRequired.periodoAnalisado
              }}
              disabled={loading}
            />
          </div>
          <div className="form-column">
            <Input
              name="youtube"
              label={nls.youtube}
              value={form.youtube}
              placeholder={nls.criardash.youtubePlaceholder}
              action={handleChange}
              disabled={loading}
            />
          </div>
        </div>

        {/* Seção de seleção de tópicos */}
        <div className="selecao-topicos">
          <label className="selecao-topicos-label normal-weight">
            {nls.selecionetopicos || "Selecione os tópicos do dashboard"}
          </label>
          
          <div className="selecao-topicos-container">
            {/* Lista de tópicos disponíveis */}
            <div className="topicos-lista topicos-disponiveis">
              <div className="topicos-lista-header">
                <span>{nls.topicosdisponiveis || "Tópicos Disponíveis"}</span>
                <span className="topicos-count">{topicosDisponiveis.length}</span>
              </div>
              <div className="topicos-lista-items">
                {topicosDisponiveis.map(topico => (
                  <div 
                    key={topico.key}
                    className="topico-item"
                    onClick={() => handleSelecionarTopico(topico)}
                  >
                    {topico.label}
                  </div>
                ))}
              </div>
            </div>

            {/* Lista de tópicos selecionados */}
            <div className="topicos-selecionados-wrapper">
              <div className="topicos-lista topicos-selecionados">
                <div className="topicos-lista-header">
                  <span>{nls.topicosselecionados || "Tópicos Selecionados"}</span>
                  <span className="topicos-count">{topicosSelecionados.length}</span>
                </div>
                <div className="topicos-lista-items">
                  {topicosSelecionados.map(topico => (
                    <div 
                      key={topico.key}
                      className="topico-item selecionado"
                      onClick={() => handleRemoverTopico(topico)}
                    >
                      {topico.label}
                    </div>
                  ))}
                </div>
              </div>
              
              {/* Mensagem de erro DENTRO do wrapper dos tópicos selecionados */}
              {erro.topicos && (
                <div className="campo-obrigatorio-topicos">
                  {nls.mensagem?.obrigatorio || "Campo obrigatório"}
                </div>
              )}
            </div>
          </div>

          {/* Botão Limpar */}
          <div className="selecao-topicos-actions">
            <Button
              color="default"
              onClick={handleLimparTopicos}
              disabled={topicosSelecionados.length === 0 || loading}
            >
              {nls.limpar || "Limpar"}
            </Button>
          </div>
        </div>
      </div>
    </div>
  )

  return (
    <Modal
      title={
      <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
        {nls.criardash?.tituloModal || "Criar Dashboard"}
        <PopoverCentralAjuda nlsContexto={nlsContexto} idarray={idarray} />
      </div>
    }
      size='large'
      open={statusModal === 'criar'}
      close={handleClose}
      closeText={nls.criarProjeto?.btnFechar || "Fechar"}
      actions={
        <>
          <Button
            color='default'
            onClick={handleClose}
            disabled={loading}
          >
            {nls.configurar?.btnCancelar || "Cancelar"}
          </Button>
          <Button
            color='primary'
            onClick={handleSubmit}
            disabled={loading}
          >
            {loading ? 'Criando...' : (nls.configurar?.btnFinalizarSalvar || 'Salvar')}
          </Button>
        </>
      }
    >
      {contentForm()}
    </Modal>
  )
}

export default Criar